module.exports = __webpack_public_path__ + "static/img/anxun81.c56fdd92.png";